// Code review - In Progress
// Documentation - In Progress
import React from "react";

const DocumentRepositroyFilePopup = ({ data }) => {
    const previewUrl = data || "";
    const fileExtension = previewUrl?.split(".").pop()?.toLowerCase();

    const isImage = ["png", "jpg", "jpeg", "gif", "webp"].includes(fileExtension);
    const isPdf = fileExtension === "pdf";
    const isWord = ["doc", "docx"].includes(fileExtension);
    const isExcel = ["xls", "xlsx"].includes(fileExtension);
    const isPPT = ["ppt", "pptx"].includes(fileExtension); // ✅

    const getViewerUrl = (url) => {
        if (!url) return "";
        const ext = url.split(".").pop().toLowerCase();
        const officeExt = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
        if (ext === "pdf") return url;
        if (officeExt.includes(ext)) {
            return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
        }
        return "";
    };

    return (
        <div className="h-100 flex items-center justify-center p-10">
            {previewUrl ? (
                isPdf || isWord || isExcel || isPPT ? ( // ✅ include isPPT
                    <iframe
                        src={getViewerUrl(previewUrl)}
                        title="File Viewer"
                        className="w-full h-[60vh] rounded"
                    />
                ) : isImage ? (
                    <img
                        src={previewUrl}
                        alt="Preview"
                        className="w-full h-auto max-h-[60vh] object-contain rounded"
                    />
                ) : (
                    <p className="text-center text-gray-600">
                        Preview not available for this file type.
                    </p>
                )
            ) : (
                <p className="text-center text-gray-600">
                    No file selected or file not available.
                </p>
            )}
        </div>
    );
};

export default DocumentRepositroyFilePopup;

